/* PDA — DEVISE DU MARCHÉ COURANT (SHOP-S16 · Lot 2)
 *
 * Ce que ce fichier résout : l'index de recherche est un JSON CDN figé EN EUROS, servi à
 * TOUS les visiteurs. On ne le reconstruit pas par marché (mesuré : 5 marchés × 3 versions
 * = 76,8 Mio). L'euro reste donc la langue interne de bout en bout — `state.ranges`, l'URL,
 * le seed, les bitsets. La devise n'existe qu'à DEUX frontières :
 *   ENTRÉE  : une borne TAPÉE (en devise) → CALAGE → euros
 *   SORTIE  : un montant euro → modèle Shopify → devise, pour être PEINT
 * exactement comme PDA.versCm / PDA.versAffichage le font pour les centimètres.
 *
 * ⛔⛔ LE PIÈGE CENTRAL DU SPRINT — NE JAMAIS INVERSER LE TAUX POUR UNE BORNE MIN.
 * `seuil = borne / taux` a été mesuré FAUX sur 240 cas certains / 252. Sur « à partir de
 * 100 € », les 63 devises sur 63 excluent les 1 928 œuvres qui affichent pourtant cette
 * valeur (7,1 % du catalogue). RAISON, et elle n'est pas une question de précision : le
 * modèle Shopify arrondit VERS LE HAUT, donc un montant affiché B est peint au SOMMET de
 * l'intervalle de prix euros qui lui correspond. B/taux tombe juste AU-DESSUS du paquet
 * d'œuvres qui affiche exactement B, et les exclut en bloc. C'est le mauvais bout de
 * l'intervalle. ⇒ on CALE la borne sur les prix réels du catalogue (recherche binaire),
 * on ne la divise jamais.
 *
 * ⛔ AUCUN TAUX N'EST GRAVÉ ICI : le batch Shopify est horaire, un taux embarqué est faux
 * avant d'être servi. Il se LIT dans la page (`Shopify.currency.rate`), et en FRACTION
 * EXACTE — le flottant contredit Shopify sur les égalités d'arrondi (mesuré : CVE à
 * 10 000 €, valeur exacte 112 470 000,5 sou, que le flottant calcule …,49999999 ⇒ 20 œuvres
 * perdues).
 *
 * Données : Context/donnees-devises/ (63 devises, 693 sondes du 28/08, non régénérables
 * sans re-sonder la boutique).
 */
(function () {
  'use strict';
  var PDA = (window.PDA = window.PDA || {});

  /* Le PAS d'arrondi de Shopify, en unité mineure. ⛔ NON DÉRIVABLE — ni des décimales
   * (d=0 donne {100,1000}, d=2 donne {1,100,1000}), ni du taux (15 paires en inversion :
   * ETB à taux 193,3 → pas 1 ; MKD à 62,9 → pas 100). Intl ne l'expose pas.
   * ⛔ Une devise ABSENTE de cette table tombe en REPLI EURO — jamais sur un défaut
   * implicite : un pas deviné à 1 fausse les 28 devises à pas ≠ 1. */
  var PAS = {
    1: 'AED AUD BAM BND BOB BSD CAD CHF CZK DKK EGP ETB GBP GMD GTQ HKD HNL ILS MDL MUR MVR NIO NZD PEN PGK PLN QAR RON SAR SEK SGD THB TWD USD UYU',
    100: 'ALL CRC CVE DJF DOP DZD HUF ISK JMD JPY KES KMF LKR MKD NPR PHP RSD XAF',
    1000: 'BIF CDF GNF IDR KRW LAK PYG SLL TZS VND',
  };

  function pasDe(code) {
    for (var p in PAS) if ((' ' + PAS[p] + ' ').indexOf(' ' + code + ' ') !== -1) return +p;
    return null;
  }

  /* Le taux est servi comme CHAÎNE : on le garde en fraction exacte N/D. */
  function lireTaux(s) {
    if (!/^[0-9]+(\.[0-9]+)?$/.test(String(s))) return null;
    var p = String(s).split('.'), f = p[1] || '';
    return { N: BigInt(p[0] + f), D: 10n ** BigInt(f.length) };
  }

  /* Les DÉCIMALES de la DEVISE (pas celles du format !). ⛔ NE PAS les dériver de la sonde :
   * MESURÉ le 29/08 sur le dev server — le marché HU rend « 1.234.568 Ft », soit ZÉRO décimale
   * affichée, alors que le modèle Shopify en compte DEUX pour HUF. Le format d'affichage et la
   * précision de la devise sont deux choses différentes, et les confondre fausse le calage.
   * (Même piège en EUR : notre money_format est amount_no_decimals, la sonde rend « 1 234 568 € ».)
   * ⛔ NE PAS non plus les dériver d'Intl : mesuré 58/63, il se trompe sur ALL HUF IDR LAK SLL.
   * SOURCE : CURRENCY_DECIMALS de assets/money-formatting.js (natif, reproduit 63/63) — cette
   * table en est l'extrait GÉNÉRÉ pour nos 63 devises servies ; 10 seulement sont non-standard,
   * toutes les autres valent 2. Régénérer si money-formatting.js change (garde G-dec). */
  var DEC_NON_STD = 'BIF:0 DJF:0 GNF:0 ISK:0 JPY:0 KMF:0 KRW:0 PYG:0 VND:0 XAF:0';

  function decimalesDe(code) {
    var i = DEC_NON_STD.indexOf(code + ':');
    return i === -1 ? 2 : +DEC_NON_STD.charAt(i + 4);
  }

  /* Le SYMBOLE se dérive de la sonde : on retire chiffres et séparateurs de
   * `{{ 123456789 | money }}`. Une seule source pour le format — celle qui peint déjà
   * les cards. Le snippet n'émet volontairement PAS de clé « symbole » : ce serait une
   * deuxième vérité à tenir synchronisée avec la première. */
  function symboleDeLaSonde(sonde) {
    if (typeof sonde !== 'string') return '';
    /* ⛔ On RETIRE LE BLOC NUMÉRIQUE, on ne filtre pas des caractères : un symbole peut
     * contenir un point — Dhs. (AED), S/. (PEN), FBu. (BIF), Gs. (PYG), 4 des 64 devises
     * servies. Le filtrage par classe les amputait (« Dhs » au lieu de « Dhs. »).
     * C'est la MÊME leçon que phNu, appliquée ici où elle manquait. */
    return sonde.replace(/[0-9][0-9.,\s\u00a0\u202f]*[0-9]|[0-9]/, '').trim();
  }

  /* ⛔ La sonde se lit TOUJOURS, indépendamment de devise(). Séparer les deux rôles :
   * devise() dit « faut-il CONVERTIR » (null en zone euro) ; sonde() dit « comment
   * FORMATER » — et le format existe même quand il n'y a rien à convertir.
   * Les confondre a produit un écart visible tous les jours : le repli euro passait par
   * toLocaleString, qui pose une espace fine U+202F (1,156 px), alors que les cards
   * passent par le format de boutique et posent U+0020 (2,672 px). Deux largeurs de
   * séparateur pour le même prix, sur le même écran. */
  var cacheSonde;
  PDA.sonde = function () {
    if (cacheSonde !== undefined) return cacheSonde;
    cacheSonde = null;
    try {
      var el = document.querySelector('script[data-pda-devise]');
      if (el) cacheSonde = (JSON.parse(el.textContent) || {}).sonde || null;
    } catch (e) { cacheSonde = null; }
    return cacheSonde;
  };

  PDA.codeSonde = function () {
    try {
      var el = document.querySelector('script[data-pda-devise]');
      return el ? ((JSON.parse(el.textContent) || {}).code || null) : null;
    } catch (e) { return null; }
  };

  var cache;
  PDA.devise = function () {
    if (cache !== undefined) return cache;
    cache = null;
    try {
      var el = document.querySelector('script[data-pda-devise]');
      if (!el) return cache;
      var cfg = JSON.parse(el.textContent);
      var sc = window.Shopify && window.Shopify.currency;
      if (!cfg || !cfg.code) return cache;
      // Repli EUR explicite (92 des 167 pays servis). ⚠️ REDONDANT avec pasDe('EUR')
      // → null deux lignes plus bas : le retirer ne change RIEN (mutant équivalent, mesuré).
      // Gardé pour que l'intention se lise sans dérouler la suite.
      if (cfg.code === 'EUR') return cache;
      if (!sc || sc.active !== cfg.code) return cache;      // témoin : marché désynchronisé
      var taux = lireTaux(sc.rate);
      var pas = pasDe(cfg.code);
      var dec = decimalesDe(cfg.code);
      if (!taux || pas == null || dec == null) return cache;
      cache = { code: cfg.code, symbole: symboleDeLaSonde(cfg.sonde), sonde: cfg.sonde, taux: taux, pas: pas, decimales: dec };
    } catch (e) { cache = null; }
    return cache;
  };

  function fdiv(a, b) { var q = a / b; return (a % b !== 0n && (a < 0n) !== (b < 0n)) ? q - 1n : q; }
  function cdiv(a, b) { var q = a / b; return (a % b !== 0n && (a < 0n) === (b < 0n)) ? q + 1n : q; }

  /* L'ORACLE — le modèle de conversion Shopify, en ENTIERS.
   *   affiché = pas × ceil( round(prix_eur × taux, décimales) / pas )
   * Falsifié le 28/08 : rejoue 693/693 sur 63 devises. Hypothèses concurrentes MORTES,
   * ne pas les rouvrir : floor 0/63 · sans arrondi 0/63 · au plus proche 1/63 · ceil seul
   * falsifié par XAF · ceil à l'unité falsifié par les 35 devises à pas 1.
   * ⚡ Rend TOUJOURS un entier en unités MAJEURES ⇒ le champ de fourchette reste un entier
   * nu dans les 63 devises, et le contrat « zone machine » du Lot 0 survit intact. */
  function affiche(eC, d, tieBas) {
    var P = 10n ** BigInt(d.decimales);
    var num = eC * d.taux.N * P, den = 100n * d.taux.D;
    var M = fdiv(2n * num + den, 2n * den);
    if (tieBas && ((2n * num + den) % (2n * den) === 0n) && (num % den !== 0n)) M -= 1n;
    return BigInt(d.pas) * cdiv(M, P * BigInt(d.pas));
  }

  PDA.prixAffiche = function (euros) {
    var d = PDA.devise();
    if (!d) return Math.round(Number(euros));
    return Number(affiche(BigInt(Math.round(Number(euros) * 100)), d, false));
  };

  /* Plus petit plafond lisible >= à la valeur exacte, dans la série
   * 1 / 2 / 2,5 / 5 × 10^n. Un plafond arrondi AU PLUS PROCHE ou vers le bas
   * exclurait les œuvres à 10 000 € dont Shopify peint la conversion au-dessus. */
  function plafondRond(n) {
    n = Number(n);
    if (!Number.isFinite(n) || n <= 0) return n;
    var puissance = 10 ** Math.floor(Math.log10(n));
    var paliers = [1, 2, 2.5, 5, 10];
    for (var i = 0; i < paliers.length; i++) {
      var candidat = paliers[i] * puissance;
      if (candidat >= n) return candidat;
    }
    return 10 * puissance;
  }

  /* FRONTIÈRE D'AFFICHAGE uniquement. `PRICE_CAP_C`, le slider, l'URL et l'index
   * restent en EUR ; seul le placeholder visible reçoit ce plafond de marché. */
  PDA.plafondPrix = function (euros) {
    return plafondRond(PDA.prixAffiche(euros));
  };

  /* CALAGE — rend un PRIX RÉEL du catalogue, en euros. Rendre un prix réel rend la borne
   * inclusive par construction : rangeBitset compare v <= max et n'a rien à changer.
   * ⛔ Jamais Infinity comme sentinelle : numOrNull (strict depuis le Lot 0) le rejetterait
   * et le filtre serait RELÂCHÉ au lieu d'être vide. */
  function prixTries() { return (PDA.prixDistinctsC && PDA.prixDistinctsC()) || null; }

  /* ⛔⛔ CONVERSION INVERSIBLE — AFFICHAGE SEULEMENT, JAMAIS UNE BORNE DE FILTRE.
   * Oui, c'est une division par le taux, et oui le sprint l'interdit — pour les BORNES.
   * La distinction est la clé de tout ce lot :
   *   · une BORNE part vers le moteur et SÉLECTIONNE des œuvres ⇒ CALAGE obligatoire,
   *     sinon 1 928 œuvres disparaissent sur « à partir de 100 € » (mesuré, 63/63 devises) ;
   *   · la POSITION D'UNE POIGNÉE ne sélectionne rien, elle place un pixel ⇒ il lui faut
   *     une fonction CONTINUE et INVERSIBLE, sinon la poignée ne peut plus bouger.
   * Mesuré le 29/08 en imposant le calage ici : la poignée ne pouvait plus ÉLARGIR
   * l'intervalle (4 ArrowUp sans effet en JPY — le calage la ramenait d'où elle venait),
   * et elle se peignait 10,66 px à côté de la borne annoncée. Deux défauts, une cause :
   * un ACCROCHAGE appliqué là où il fallait une CONVERSION.
   * ⛔ Ne JAMAIS router une valeur issue d'ici vers setRange ni vers l'URL. */
  /* Formate un montant DANS LE FORMAT EXACT DU MARCHÉ — symbole, position, séparateurs
   * et décimales — en remplaçant la partie numérique de la SONDE, elle-même rendue par
   * `| money`. C'est la seule façon d'obtenir ce que peignent les cards sans
   * réimplémenter leur format, et donc la seule qui ne puisse pas en diverger.
   * Cote Sam 29/08 : le chip prend la forme des cards (« ¥56,800 », pas « 56 800 ¥ »). */
  function formaterMontantDevise(n, d, sansDecimales) {
    /* Une SEULE source de format, y compris en zone euro : la sonde, rendue par le même
     * filtre `| money` que les cards. C'est ce qui garantit que le chip et la card
     * peignent le même prix avec le même séparateur. */
    /* ⛔ Sans devise CONVERTIBLE, on ne peut pas habiller un montant euro d'un symbole
     * étranger : ce serait un prix faux, présenté comme juste. Mesuré en bac à sable —
     * une devise servie mais absente de la table des pas (MAD, INR, TRY, BRL, MXN…, le
     * jour où un marché en ouvre une) aurait peint « 1 350 MAD » à côté de cards à
     * ~14 700 MAD. Le repli est euro pour le montant ET pour le format. */
    /* Fondé sur la config LUE (elle porte le code), pas sur window.Shopify.currency :
     * cet objet peut manquer ou être incomplet, et le repli ne se déclencherait pas —
     * on peindrait alors un montant EURO dans un format étranger. On ne dépend que de
     * ce qu'on a déjà entre les mains. */
    var etranger = !d && PDA.sonde() && PDA.codeSonde() !== 'EUR';
    var sonde = d && d.sonde ? d.sonde : (etranger ? null : PDA.sonde());
    var dec = d ? d.decimales : 0;
    if (!sonde) return (PDA.nombre ? PDA.nombre(n) : String(n)) + '\u00a0€';
    var m = sonde.match(/[0-9][0-9.,\s\u00a0\u202f]*[0-9]|[0-9]/);
    if (!m) return String(n);
    var bloc = m[0];
    // Séparateur de GROUPE : le premier non-chiffre du bloc qui n'est pas la décimale.
    var queue = dec > 0 ? new RegExp('([^0-9])[0-9]{' + dec + '}$') : null;
    var decSep = queue ? (bloc.match(queue) || [])[1] : null;
    var corps = decSep ? bloc.slice(0, bloc.lastIndexOf(decSep)) : bloc;
    var grpSep = (corps.match(/[^0-9]/) || [''])[0];
    var txt = String(n);
    if (grpSep) txt = txt.replace(/\B(?=(\d{3})+(?!\d))/g, grpSep);
    /* ⛔ Ne PAS poser les décimales quand l'appelant n'en veut pas (le placeholder).
     * Les RETIRER après coup supposerait qu'elles ont été posées — faux dès qu'une
     * devise a des décimales au MODÈLE mais aucune à l'AFFICHAGE. Mesuré sur HUF :
     * la coupe mangeait deux chiffres DU MONTANT, « 7.5 » pour une borne de 7 500.
     * Le piège est décrit douze lignes plus haut dans ce fichier ; je ne l'avais pas relu. */
    if (decSep && !sansDecimales) txt += decSep + new Array(dec + 1).join('0');
    return sonde.replace(bloc, txt);
  }

  PDA.formaterPrix = function (euros, sansDecimales) {
    var d = PDA.devise();
    return formaterMontantDevise(PDA.prixAffiche(euros), d, sansDecimales);
  };

  /* Même format que les cards, mais appliqué au plafond ROND du marché. Cette API
   * évite de regrouper le montant avec la locale du texte : le séparateur monétaire
   * vient toujours de la sonde Shopify, y compris quand locale et marché diffèrent. */
  PDA.formaterPlafondPrix = function (euros, sansDecimales) {
    var d = PDA.devise();
    return formaterMontantDevise(PDA.plafondPrix(euros), d, sansDecimales);
  };

  /* Le Liquid ne sait pas extraire un symbole ponctué sans regex : sa valeur SSR retire
   * aussi le point de Dhs. / S/. / FBu. / Gs. On repeint donc TOUS les suffixes depuis
   * LA MÊME sonde que les cards. Fail-closed : si une devise étrangère n'est pas
   * convertible, une borne restée en euros reçoit « € », jamais un symbole étranger. */
  PDA.peindreSymbolesDevise = function (racine) {
    if (!racine || typeof racine.querySelectorAll !== 'function') return 0;
    var noeuds = racine.querySelectorAll('[data-pda-devise-symbole]');
    if (!noeuds || !noeuds.length) return 0;
    var d = PDA.devise();
    var symbole = d && d.symbole ? d.symbole : (PDA.codeSonde() !== 'EUR' ? '€' : '');
    if (!symbole) return 0;
    for (var i = 0; i < noeuds.length; i++) noeuds[i].textContent = symbole;
    return noeuds.length;
  };

  /* Les trois tranches du méga-menu sont partagées desktop + drawer. Le libellé
   * parle la devise du marché, mais les hrefs et leurs bornes restent en euros. */
  PDA.peindrePrixNavigation = function (racine) {
    if (!racine || typeof racine.querySelectorAll !== 'function' || typeof PDA.t !== 'function') return 0;
    var noeuds = racine.querySelectorAll('[data-pda-prix-cle]');
    if (!noeuds || !noeuds.length) return 0;
    var peints = 0;
    for (var i = 0; i < noeuds.length; i++) {
      var el = noeuds[i], cle = el.getAttribute('data-pda-prix-cle');
      if (!cle) continue;
      var params = {};
      var min = el.getAttribute('data-pda-prix-min');
      var max = el.getAttribute('data-pda-prix-max');
      if (min != null && /^[0-9]+(?:\.[0-9]+)?$/.test(min)) params.min = PDA.formaterPrix(Number(min));
      if (max != null && /^[0-9]+(?:\.[0-9]+)?$/.test(max)) params.max = PDA.formaterPrix(Number(max));
      el.textContent = PDA.t(cle, params);
      peints++;
    }
    return peints;
  };

  /* Le header Horizon hydrate ses sous-arbres en idle APRES les scripts defer et
   * remorphe alors les text nodes depuis le SSR EUR. Repeindre une seconde fois
   * uniquement sur son signal de fin ; observer childList se réveillerait sur
   * notre propre textContent et créerait une boucle. */
  function surveillerHydratationNavigation(racine) {
    if (!racine || typeof racine.querySelector !== 'function' || typeof window.MutationObserver !== 'function') return false;
    var section = racine.querySelector('.shopify-section.header-section');
    if (!section || typeof section.getAttribute !== 'function') return false;
    var repeindreSiHydrate = function () {
      if (section.getAttribute('data-hydrated') !== 'true') return false;
      PDA.peindrePrixNavigation(racine);
      return true;
    };
    if (repeindreSiHydrate()) return true;
    var observateur = new window.MutationObserver(function () {
      if (!repeindreSiHydrate()) return;
      observateur.disconnect();
    });
    observateur.observe(section, { attributes: true, attributeFilter: ['data-hydrated'] });
    return true;
  }

  /* Script `defer` : le DOM est complet ici. Les auto-appels sont couverts en
   * exécution ; une fonction exacte mais jamais appelée était précisément le défaut.
   * L'observer ferme ensuite la course avec l'hydratation différée du header. */
  PDA.peindreSymbolesDevise(document);
  PDA.peindrePrixNavigation(document);
  surveillerHydratationNavigation(document);

  PDA.versEuros = function (montantDevise) {
    var d = PDA.devise();
    if (!d) return Number(montantDevise);
    return Number(montantDevise) * Number(d.taux.D) / Number(d.taux.N);
  };

  PDA.calageMin = function (B) {
    var d = PDA.devise(), px = prixTries();
    if (!d || !px || !px.length) return Number(B);
    var b = BigInt(Math.round(Number(B))), lo = 0, hi = px.length;
    while (lo < hi) { var m = (lo + hi) >> 1; if (affiche(px[m], d, false) >= b) hi = m; else lo = m + 1; }
    return lo < px.length ? Number(px[lo]) / 100 : Number(px[px.length - 1] + 100n) / 100;
  };

  PDA.calageMax = function (B) {
    var d = PDA.devise(), px = prixTries();
    if (!d || !px || !px.length) return Number(B);
    var b = BigInt(Math.round(Number(B))), lo = -1, hi = px.length - 1;
    while (lo < hi) { var m = (lo + hi + 1) >> 1; if (affiche(px[m], d, true) <= b) lo = m; else hi = m - 1; }
    return lo >= 0 ? Number(px[lo]) / 100 : Number(px[0] - 100n) / 100;
  };

  PDA._pasDe = pasDe;            // exposés pour la garde, pas pour le rendu
  PDA._lireTaux = lireTaux;
  PDA._affiche = affiche;
  PDA._decimalesDe = decimalesDe;
  PDA._symboleDeLaSonde = symboleDeLaSonde;
  PDA._plafondRond = plafondRond;
  PDA._NB_DEVISES = 63;
})();
